import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import '../Icon/components/index.js';
import '../Icon/Icon.js';
import '../Accordion/Accordion.js';
import '../Backdrop/Backdrop.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Badge/Badge.js';
import '../Tooltip/Tooltip.js';
import { IconButton } from '../IconButton/IconButton.js';
import '../Banner/Banner.js';
import '../Button/Button.js';
import '../Spinner/Spinner.js';
import '../Toast/Toaster.js';
import '../Provider/Provider.js';
import '../Calendar/Calendar.js';
import '../Checkbox/Checkbox.js';
import '../../utils/hooks/useProxiedRef.js';
import '../Input/Input.js';
import '../../utils/hooks/useListKeyboardNavigation.js';
import '../../utils/hooks/useListScrollTo.js';
import '../../utils/hooks/useBoundingClientRectListener.js';
import '../Combobox/Combobox.js';
import '../../utils/date.js';
import '../../utils/mergeRefs.js';
import '../Popover/Popover.js';
import '../Datepicker/Datepicker.js';
import '../Dialog/Dialog.js';
import '../Field/Field.js';
import '../Form/Form.js';
import '../Group/Group.js';
import '../Hanger/Hanger.js';
import '../HoverCard/HoverCard.js';
import '../SearchInput/SearchInput.js';
import '../Listbox/Listbox.js';
import '../RadioGroup/RadioGroup.js';
import '../Menu/Menu.js';
import '../Treeview/Treeview.js';
import '../../utils/hooks/useDropTarget.js';
import '../Navigation/Navigation.js';
import '../Select/Select.js';
import '../Pagination/usePagination.js';
import '../Pagination/Pagination.js';
import '../Progress/Progress.js';
import '../Table/components/Table.js';
import '../Table/components/PaginatedTable.js';
import '../Table/components/WindowedTable.js';
import '../Table/util/rowIndexPath.js';
import '../Table/hooks/useRowCreation.js';
import '../Tabs/Tabs.js';
import '../Textarea/Textarea.js';
import '../Switch/Switch.js';
import '../Tour/Tour.js';
import '../../utils/hooks/useOnClickOutside.js';

const Content = /*#__PURE__*/forwardRef(function CardContent(externalProps, ref) {
  const {
    noPadding,
    ...props
  } = externalProps;
  const className = cn('flex-grow overflow-auto', {
    'mx-4 mb-4': !noPadding
  }, props.className);
  return createElement("div", Object.assign({}, props, {
    className: className,
    ref: ref
  }));
});
const Card = /*#__PURE__*/forwardRef(function Card(props, ref) {
  const {
    title,
    menu,
    children
  } = props;
  const className = cn('bg-white flex flex-col rounded-xl shadow-[0px_0px_1px_rgba(0,0,0,0.1),0px_6px_18px_rgba(47,51,68,0.2)]', props.className);
  return createElement("div", {
    className: className,
    "data-taco": "card",
    ref: ref
  }, createElement("div", {
    className: "mx-4 mt-4 mb-2 flex"
  }, title && createElement("h4", {
    className: "mb-0 flex-grow text-left"
  }, title), menu ? createElement(IconButton, {
    icon: "ellipsis-horizontal",
    appearance: "discrete",
    menu: menu,
    className: "-mt-[4px]"
  }) : null), children);
});
Card.Content = Content;

export { Card };
//# sourceMappingURL=Card.js.map
